
import { Vue, Component, Prop, Watch } from "vue-property-decorator";

@Component({})
export default class RightsForm extends Vue {
  @Prop({default: () => []})
  public allRights: any[];

  @Prop({default: () => []})
  public initRights: any[];

  @Prop({default: false})
  public disabled: boolean;

  private currentRights: any[] = [];
  private categories: Array<{
    name: string,
    displayRights: boolean,
    allChecked: boolean,
    key: number,
  }> = [];

  @Watch("allRights")
  @Watch("initRights")
  public handlerRightsChange(): void {
    if (this.allRights.length && this.initRights.length) {
      this.resetCurrentRights();
    }
  }

  private mounted(): void {
    this.resetCurrentRights();
  }

  private resetCurrentRights(): void {
    this.currentRights = this.allRights.map((right) => ({
      ...right,
      isChecked: !!this.initRights.find((r) => r.rightId === right.id),
    }));
    const categories = [...new Set(this.allRights.map((r) => r.category).filter(Boolean))];
    this.categories = categories.map((c) => ({
      name: c,
      key: Math.random(),
      displayRights: false,
      allChecked: !this.currentRights.find((r) => r.category === c && !r.isChecked),
    }));
    this.checkCategoriesDisplayRights();
  }

  private checkCategoriesDisplayRights(): void {
    this.categories.forEach((c) => {
      const checkedCount: number = this.currentRights.filter((r) => r.category === c.name && r.isChecked).length;
      if (checkedCount === 0 || c.allChecked) {
        c.displayRights = false;
      } else if (checkedCount > 0 && !c.allChecked) {
        c.displayRights = true;
      }
    });
  }

  private handleCategoryCheck(categoryName: string): void {
    const category = this.categories.find((c) => c.name === categoryName);
    this.currentRights.forEach((e) => {
      if (e.category === categoryName) {
        e.isChecked = category.allChecked;
      }
    });
    category.key = Math.random();
  }

  private handleRightCheck(right: any): void {
    // Update current right checkbox
    right.isChecked = !right.isChecked;
    this.currentRights.find((r) => r.id === right.id).isChecked = !right.isChecked;
    // Check if all other right of this category are checked or unchecked to update the parent checkbox
    if (right.category) {
      const category = this.categories.find((c) => c.name === right.category);
      category.allChecked = !this.currentRights.find((r) => r.category === right.category && !r.isChecked);
    }
  }
}
